import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPosition } from "src/models/HumanResources/Positions.models";

interface PositionState {
  positions: IPosition[];
  positionsButMe: IPosition[];
  positionsByParent: IPosition[];
  positionToEdit: IPosition | null;
}

const initialState: PositionState = {
  positions: [],
  positionsButMe: [],
  positionsByParent: [],
  positionToEdit: null,
};

const PositionSlice = createSlice({
  name: "Position",
  initialState,
  reducers: {
    setPositionList: (state, action: PayloadAction<IPosition[]>) => {
      state.positions = action.payload;
    },
    setMyPositionList: (state, action: PayloadAction<IPosition[]>) => {
      state.positionsButMe = action.payload;
    },
    setPositionFlowList: (state, action: PayloadAction<IPosition[]>) => {
      state.positionsByParent = action.payload;
    },
    concatListPosition: (
      state: PositionState,
      action: PayloadAction<IPosition[]>
    ) => {
      state.positions = [...state.positions.concat(action.payload)];
    },
    setPositionToEdit: (state, action: PayloadAction<IPosition | null>) => {
      state.positionToEdit = action.payload;
    },
    addPosition: (state, action: PayloadAction<IPosition>) => {
      state.positions.push(action.payload);
    },
    updatePosition: (state, action: PayloadAction<IPosition>) => {
      let itemIndex = state.positions.findIndex(
        item => item.positionId === action.payload.positionId
      );
      if (itemIndex !== -1) state.positions[itemIndex] = action.payload;
    },
    deletePosition: (state, action: PayloadAction<number>) => {
      const newArray = state.positions.filter(
        item => item.positionId !== action.payload
      );
      state.positions = newArray;
    },
  },
});

export const {
  setPositionList,
  setMyPositionList,
  setPositionFlowList,
  concatListPosition,
  setPositionToEdit,
  addPosition,
  updatePosition,
  deletePosition,
} = PositionSlice.actions;

export default PositionSlice.reducer;
